import { SIGNALR_EVENT_NAMES } from '../constants';
import { locationUpdated } from '../eventHandlers/driverLocationHandler';
import {
  accessibleTerminalUpdated,
  bobtailProcessed,
  dispatchCanceled,
  dispatchUpdate,
  dollyDropHookProcessed,
  driverAssigned,
  driverDispatched,
  driverLoginStatusUpdate,
  duplicatePickupsDetected,
  geofenceArrivalDeparture,
  kpiUpdated,
  messageFromDriver,
  messageRead,
  moveBillsProcessed,
  pickupAcknowledged,
  pickupAssigned,
  pickupUnassigned,
  pickupUpdated,
  pickupsMerged,
  plannedKPIUpdated,
  proAdded,
  proDeleted,
  stopMoved,
  trailerDropped,
  trailerHooked,
  trailerStatusUpdated,
  updateFromDriverApp,
  pickupRecommendationsAvailable,
  shipperUpdatedFromIBPlanning,
  revisitDeliveryStop,
  trailerClosed,
  trailerMovesUpdated
} from '../eventHandlers/dispatch';

const { DISPATCH } = SIGNALR_EVENT_NAMES;
export const setupDispatchEventListeners = (connection) => {
  connection.on(DISPATCH.dispatchCancelled, dispatchCanceled);
  connection.on(DISPATCH.pickupAssigned, pickupAssigned);
  connection.on(DISPATCH.pickupUnassigned, pickupUnassigned);
  connection.on(DISPATCH.driverAssigned, driverAssigned);
  connection.on(DISPATCH.driverRouteUpdated, updateFromDriverApp);
  connection.on(DISPATCH.proAdded, proAdded);
  connection.on(DISPATCH.dollyDropHookProcessed, dollyDropHookProcessed);
  connection.on(DISPATCH.trailerHooked, trailerHooked);
  connection.on(DISPATCH.trailerDropped, trailerDropped);
  connection.on(DISPATCH.bobtailProcessed, bobtailProcessed);
  connection.on(DISPATCH.moveBillsProcessed, moveBillsProcessed);
  connection.on(DISPATCH.dispatchUpdate, dispatchUpdate);
  connection.on(DISPATCH.proDeleted, proDeleted);
  connection.on(DISPATCH.plannedKPIUpdated, plannedKPIUpdated);
  connection.on(DISPATCH.pickupUpdated, pickupUpdated);
  connection.on(DISPATCH.duplicatePickupsDetected, duplicatePickupsDetected);
  connection.on(DISPATCH.locationUpdated, locationUpdated);
  connection.on(DISPATCH.messageFromDriver, messageFromDriver);
  connection.on(DISPATCH.messageRead, messageRead);
  connection.on(DISPATCH.driverLoginStatusUpdate, driverLoginStatusUpdate);
  connection.on(DISPATCH.driverDispatched, driverDispatched);
  connection.on(DISPATCH.stopMoved, stopMoved);
  connection.on(DISPATCH.trailerStatusUpdated, trailerStatusUpdated);
  connection.on(DISPATCH.pickupAcknowledged, pickupAcknowledged);
  connection.on(DISPATCH.pickupsMerged, pickupsMerged);
  connection.on(DISPATCH.accessibleTerminalUpdated, accessibleTerminalUpdated);
  connection.on(DISPATCH.kpiUpdated, kpiUpdated);
  connection.on(DISPATCH.pickupRecommendationsAvailable, pickupRecommendationsAvailable);
  connection.on(DISPATCH.geofenceArrivalDeparture, geofenceArrivalDeparture);
  connection.on(DISPATCH.shipperUpdatedFromIBPlanning, shipperUpdatedFromIBPlanning);
  connection.on(DISPATCH.revisitDeliveryStop, revisitDeliveryStop);
  connection.on(DISPATCH.trailerClosed, trailerClosed);
  connection.on(DISPATCH.trailerMovesUpdated, trailerMovesUpdated);
};
